import {Component, inject, Inject, OnDestroy, OnInit, signal} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatButton, MatIconButton} from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatError, MatFormField} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {catchError, of, tap} from "rxjs";
import {ContentData} from "../../../common/abstracts/content/content";
import {ContentService} from "../../../services/content/content.service";
import {LoaderComponent} from "../../loader/loader.component";

@Component({
  selector: 'app-content-modal',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatDialogContent,
    MatError,
    MatFormField,
    MatIcon,
    MatInput,
    ReactiveFormsModule,
    MatDialogActions,
    MatDialogClose,
    MatIconButton,
    MatDialogTitle,
    LoaderComponent
  ],
  templateUrl: './content-modal.component.html',
  styleUrl: './content-modal.component.scss'
})
export class ContentModalComponent extends ContentData {

  private contentService = inject(ContentService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: { contentId: any }) {
    super();
  }


  init() {
    this.isLoading.set(true);
    const sub = this.contentService.getContent(this.data.contentId).pipe(
      catchError((err) => {
        this.isLoading.set(false);
        return of(null);
      }),
    ).subscribe(data => {
      this.isLoading.set(false);
      this.contentData.set(data);
    });
    this.subscription.add(sub);
  }


}
